import { createAction, props } from '@ngrx/store';
import { Group } from '@shared/models/group';

export const loadGroup = createAction('[Groups] Load Group', props<{ groupId: string; groupName?: string }>());

export const loadGroupSuccess = createAction('[Groups] Load Group Success', props<{ group: Group }>());

export const loadGroupFailure = createAction('[Groups] Load Group Failure', props<{ error: any }>());
